import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/homePage/store/mutations";
import { getters } from "@/components/homePage/store/getters";
import { actions } from "@/components/homePage/store/actions";
import { HomePageState } from "@/components/homePage/types";

export const state: HomePageState = {
  playedChannelIndex: undefined,
  widgetKeyControl: false,
  activeSlideIndexMap: [],
  playedWidgetIndex: undefined,
  promotionKeyControl: false
};

export const homePage: Module<HomePageState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
